import { init } from '@sentry/react';

const DSN = 'https://52a3a06c27a1f1831e7245a5aaebf1d5@o4507034136870912.ingest.us.sentry.io/4508800280756224';

init({
  dsn: DSN,
  maxBreadcrumbs: 20,
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT,
  beforeSend(event, hint) {
    // @ts-ignore
    if (event?.message || hint?.captureContext?.contexts?.react) {
      return event;
    }

    return null;
  },
});
